export default "__VITE_ASSET__WGFPpsEx__"